import React from 'react';
import { GaintOFDOrdersContextProvider } from '../../context/GaintOFDOrdersContext';
import GaintOFDOrdersView from './GaintOFDOrdersView';

const GaintOFDOrders = () => {
    return (
        <GaintOFDOrdersContextProvider>
            <GaintOFDOrdersView />
        </GaintOFDOrdersContextProvider>
    );
};

export default GaintOFDOrders;
